module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-wrap"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profilePhoto),
      expression: "profilePhoto"
    }],
    staticClass: "img",
    attrs: {
      "src": _vm.photoComp,
      "crossOrigin": "Anonymous"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22e5e915!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Profile/ProfilePhotoView.vue
// module id = 616
// module chunks = 2